import generateUUID from 'syf-js-utilities/helpers/generateUUID';
var getTrackingId = {
    uuidValue: function () {
        return generateUUID();
    }
};
export default getTrackingId;
